/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_4_DetailInputs */

const en_cap_full_mock_4_detail = /** @type {(inputs: Cap_Full_Mock_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chosen for each task`)
};

const lv_cap_full_mock_4_detail = /** @type {(inputs: Cap_Full_Mock_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlēti katram uzdevumam`)
};

/**
* | output |
* | --- |
* | "Chosen for each task" |
*
* @param {Cap_Full_Mock_4_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_4_detail = /** @type {((inputs?: Cap_Full_Mock_4_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_4_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_4_detail(inputs)
	return en_cap_full_mock_4_detail(inputs)
});